import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AvatarUploader from '@blade/common/components/avatar-uploader.vue';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { EType } from '@blade/common/interfaces/user-group';
import { handleError } from '@blade/common/utils/handle-error';
import EditMessages, { CreateStaff } from '@blade-sxp/pass/lang/edit';
import moment from 'moment';
import { merge } from 'lodash';
import GenderSelect from '@blade-sxp/pass/components/gender-select.vue';
import { overlapGroup } from '@blade-sxp/pass/utils/overlap-group';
import EncryptInput from '@blade/common/components/encrypt-input.vue';
let default_1 = class extends Vue {
    remoteAvatarURL = '';
    title = '';
    currId = 'CREATE';
    form = {
        name: '',
        gender: '',
        countryId: '',
        phone: '',
        email: '',
        portraitLibIds: [],
        identityId: '',
        icCard: '',
        birthDay: '',
        image: '',
        personGroup: EType.BLACKLIST,
    };
    tags = [
        { name: 'Tag 1', key: 0 },
        { name: 'Tag 2', key: 1 },
        { name: 'Tag 3', key: 2 },
        { name: 'Tag 4', key: 3 },
        { name: 'Tag 5', key: 4 },
    ];
    avatar = '';
    options = [{ label: 'staff1', value: '11' }];
    id = '';
    get whitegroup() {
        return {
            name: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!this.form.name) {
                        callback(new Error(this.$t('nameError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
            portraitLibIds: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    console.log('portrait id:', this.form.portraitLibIds);
                    if (this.form.portraitLibIds.length === 0) {
                        callback(new Error(this.$t('groupError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
            image: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!this.form.image) {
                        callback(new Error(this.$t('imageError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
        };
    }
    handleClose(e) {
        console.log('e:', e);
    }
    handleDelete() {
        this.tags = [];
    }
    handleAvatar(url) {
        this.form.image = url;
    }
    async mounted() {
        const { meta, params } = this.$route;
        console.log('router:', meta);
        this.title = meta.page;
        this.id = params.id;
        await this.getPortraitIds();
        if (meta.page === 'editBlack') {
            this.currId = 'EDIT';
            this.getData();
        }
    }
    async getData() {
        try {
            const res = await StaffModule.getPortraitById(this.id);
            const { data } = res;
            if (!data) {
                return;
            }
            const { phone, countryId, url } = data;
            if (url) {
                this.remoteAvatarURL = url;
            }
            this.form = {
                name: data.name,
                gender: data.gender,
                portraitLibIds: overlapGroup(data.portraitLibIds, this.options),
                phone,
                countryId: countryId.substr(0, 10),
                email: data.email,
                icCard: data.icCard,
                birthDay: data.birthDay,
                identityId: data.identityId,
                image: data.url,
                personGroup: EType.BLACKLIST,
            };
            console.log('form:', this.form);
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    async getPortraitIds() {
        try {
            const res = await StaffModule.getPortraitsGroup({ data: EType.BLACKLIST, mode: this.currId });
            const mappedIds = this.mapOptions(res.data);
            this.options = mappedIds;
        }
        catch (e) { }
    }
    mapOptions(data) {
        const res = data.map((item) => {
            return { label: item.name, value: item.libId };
        });
        return res;
    }
    genderChange(v) {
        this.form.gender = v;
    }
    handleSubmit() {
        this.$refs['staff-form'].validate((valid) => {
            if (valid) {
                this.form.birthDay = this.form.birthDay === '' || this.form.birthDay === null || this.form.birthDay === 'Invalid date'
                    ? ''
                    : moment(this.form.birthDay).format('YYYY-MM-DD');
                if (this.title === 'createBlack') {
                    this.createStaff();
                }
                else {
                    this.updateStaff();
                }
            }
            else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    async createStaff() {
        try {
            await StaffModule.createPasssstaff(this.form);
            this.$elmessage.success(this.$t('createSuccess').toString());
            this.$router.push({ path: '/traffic/staff/black', query: { group: 'STAFF' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    async updateStaff() {
        try {
            await StaffModule.updatePortrait({
                paramStaff: { ...this.form },
                id: this.id,
            });
            this.$elmessage.success(this.$t('editSuccess').toString());
            this.$router.push({ path: '/traffic/staff/black', query: { group: 'STAFF' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    handleCancel() {
        this.$router.push({ path: '/traffic/staff/black', query: { group: 'STAFF' } });
    }
};
default_1 = __decorate([
    Component({
        name: 'CreatePortrait',
        components: { AvatarUploader, GenderSelect, EncryptInput },
        i18n: {
            messages: {
                'en-us': {
                    upload: 'Please upload the portrait',
                    createBlack: 'Create Blocklist Memeber',
                    groupName: 'Blocklist Group Name',
                    groupAccess: 'Blocklist Group Access',
                    access: 'Please input name/organization',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    editBlack: 'Edit Blocklist Member',
                    name: 'Name',
                    gender: 'Gender',
                    phone: 'Phone Number',
                    position: 'Position',
                    email: 'Email',
                    icCard: 'IC Card',
                    address: 'Working Addr',
                    birthday: 'Birthday',
                    identity: 'ID Card',
                    nameError: 'Name is required',
                    groupError: 'Please input group',
                    imageError: 'Please input image',
                    blackGroup: 'Blocklist group  (multiple supported)'
                },
                zh: {
                    upload: '请上传人像',
                    createBlack: '创建黑名单访客',
                    groupName: '人员组名称',
                    groupAccess: '人员组权限',
                    access: '请输入姓名/部门',
                    submit: '确认',
                    cancel: '取消',
                    editBlack: '编辑黑名单访客',
                    name: '姓名',
                    gender: '性别',
                    blackGroup: '所属黑名单组（可多选）',
                    phone: '手机号',
                    position: '企业及职位',
                    email: '邮箱',
                    icCard: 'IC卡号',
                    address: '工作地点',
                    birthday: '出生日期',
                    identity: '身份证号',
                    nameError: '请填名字',
                    groupError: '请选人员组',
                    imageError: '请选头像',
                },
            },
            sharedMessages: merge({}, EditMessages, CreateStaff)
        },
    })
], default_1);
export default default_1;
